/**
 * @generated SignedSource<<517b5281d8ce900443619c37596a52ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionPageUpsertInput = {
  bannerBackgroundColor: string;
  bannerImage: Upload;
  bannerSubText: string;
  bannerSubTextColor: string;
  bannerTitle: string;
  bannerTitleColor: string;
  detailBackgroundColor: string;
  detailButtonLink: string;
  detailButtonText: string;
  detailImages?: ReadonlyArray<DetailImageDeeplinkInput> | null;
  miniBannerSubText: string;
  miniBannerTitle: string;
  promotionId: string;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type DetailImageDeeplinkInput = {
  deeplink: string;
  image: Upload;
};
export type PromotionPageUpsertDialog_promotionPageUpsertMutation$variables = {
  input: PromotionPageUpsertInput;
};
export type PromotionPageUpsertDialog_promotionPageUpsertMutation$data = {
  readonly promotionPageUpsert: {
    readonly bannerTitle: string;
  };
};
export type PromotionPageUpsertDialog_promotionPageUpsertMutation = {
  response: PromotionPageUpsertDialog_promotionPageUpsertMutation$data;
  variables: PromotionPageUpsertDialog_promotionPageUpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionPage",
    "kind": "LinkedField",
    "name": "promotionPageUpsert",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bannerTitle",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionPageUpsertDialog_promotionPageUpsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionPageUpsertDialog_promotionPageUpsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4cd38151577e895bf0912fbcc7819c71",
    "id": null,
    "metadata": {},
    "name": "PromotionPageUpsertDialog_promotionPageUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionPageUpsertDialog_promotionPageUpsertMutation(\n  $input: PromotionPageUpsertInput!\n) {\n  promotionPageUpsert(input: $input) {\n    bannerTitle\n  }\n}\n"
  }
};
})();

(node as any).hash = "59b7acee6431e10e0c8fd683b14ab00b";

export default node;
